<template>
  <div class="container-item story">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">          
            
            <div class="storytelling">
              <div class="">
                <p v-html="cardText.text"></p>
              </div>              
            </div>
            
        </div>
      </div>    
  </div>
</template>

<script>


export default {
  name: 'ScrollCard',
  props: {
    cardText: Object
  }
}
</script>
